// extracted by mini-css-extract-plugin
export default {"H1":"h1_H1__LHss8","IconLeft":"h1_IconLeft__yA6By","IconRight":"h1_IconRight__ijlkh","Huge":"h1_Huge__6XDCx"};